import styled from 'styled-components';
import theme from 'styled-theming';
import colors from '../../../theme/Colors';

const subHeaderColor = theme.variants('brand', 'kind', {
    primary: {brenntag: colors.brenntag.primary, bcd: colors.bcd.secondary}
});

interface SubHeaderProps {
    kind?: string;
}

export const ProfileWrapper = styled.div`
    margin-left: auto;
    margin-right: auto;
    background-color: white;
    padding: 20px;
    max-width: 90%;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
    @media (min-width: 700px) {
        padding: 40px;
    }
`;

export const SSubHeader = styled.h3<SubHeaderProps>`
    color: ${subHeaderColor};
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
`;